export default __webpack_public_path__ + "static/media/darkCheck.8990c812.svg";